/** Datos de marca y contacto de Industrias Teyco (Grupo Teyco). */
export const TEYCO = {
  name: 'Grupo Teyco',
  line: 'Techos Móviles',
  product: 'Pérgola Bioclimática',
  address: 'C/ Juan de la Cierva, Parc. 26/1, Pol. Ind. Oeste, 30169 San Ginés, Murcia (Spain)',
  phone: '+34 968 880 621',
  email: 'teyco@teyco-sl.com',
  web: 'industriasteyco.com',
  brands: ['TEYCO', 'DIAL', 'DGLASS'],
  primary: '#00a19b',
  primaryDark: '#00827d',
  dark: '#1a1d21',
} as const;

/** Genera un identificador de presupuesto: TEYCO-YYYYMMDD-XXXX. */
export function makeQuoteId(date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const rnd = Math.floor(1000 + Math.random() * 9000);
  return `TEYCO-${y}${m}${d}-${rnd}`;
}
